import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';

const AppLayout: React.FC = () => {
  const [theme, setTheme] = useState<string>(() => localStorage.getItem('phoenixTheme') || 'light');
  const [headerHeight, setHeaderHeight] = useState<number>(0);
  useEffect(() => { document.documentElement.setAttribute('data-bs-theme', theme); }, [theme]);
  const toggleTheme = () => {
    const next = theme === 'light' ? 'dark' : 'light';
    setTheme(next);
    localStorage.setItem('phoenixTheme', next);
    // notify other components in the same window to react to theme change
    try { window.dispatchEvent(new CustomEvent('phoenixThemeChange', { detail: next })); } catch (e) {}
  };

  // measure header height and expose as main margin-top to avoid content overlapping fixed header
  useEffect(() => {
    const update = () => {
      const headerEl = document.querySelector('.header.fixed-top') as HTMLElement | null;
      const h = headerEl ? Math.ceil(headerEl.getBoundingClientRect().height) : 0;
      setHeaderHeight(h);
    };

    update();
    window.addEventListener('resize', update);

    const headerEl = document.querySelector('.header') as HTMLElement | null;
    let mo: MutationObserver | null = null;
    if (headerEl && 'MutationObserver' in window) {
      mo = new MutationObserver(() => update());
      mo.observe(headerEl, { attributes: true, childList: false, subtree: false });
    }

    return () => {
      window.removeEventListener('resize', update);
      if (mo) mo.disconnect();
    };
  }, []);

  return (
    <>
      <Header theme={theme} toggleTheme={toggleTheme} />
      <main style={{ marginTop: headerHeight ? headerHeight + 12 : 0 }}>
        <Outlet />
      </main>
    </>
  );
};

export default AppLayout;
